import styles from './UnclaimedPage.module.css';
// import AutoResaleOffIcon from '@assets/icons/gear-with-sprocket-grey-21.svg';
// import AutoResaleOnIcon from '@assets/icons/gear-with-sprocket-blue-21.svg';
import AutoResaleUnclaimedModalWindow from '@components/modals/AutoResaleUnclaimedModalWindow';
import AwaitingTab from './tabs/AwaitingTab.tsx';
import Box from '@components/Box';
import cn from 'classnames';
import DisposalTab from './tabs/DisposalTab.tsx';
import ExcelIcon from '@assets/icons/xlx-white-19.svg';
import FilterIcon from '@assets/icons/filter.svg';
import moment from 'moment';
import Page from '@components/Page/Page.tsx';
import ResaleTab from './tabs/ResaleTab.tsx';
//import RescueTab from './tabs/RescueTab.tsx';
import ReturnsTab from './tabs/ReturnsTab.tsx';
import UnpaidTab from './tabs/UnpaidTab.tsx';
import useTab from '@hooks/useTab';
import { AxiosResponse } from 'axios';
import { Button, ButtonSize, ButtonType } from '@components/Button';
import { FilterModel } from '@hooks/useFiltersSearchParams';
import { Filters, FilterTypes } from '@containers/Filters';
import { getAutoResaleUnclaimedData, getCountryTariffs } from '@api/apiClient';
import {
  getReturnsXLSXFile,
  getReturnsXLSXFileRequest,
  useAwaitingCounter,
  useUnpaidCounter,
  useDisposalCounter,
  useHasReturns,
  useResaleCounter,
  useReturnsCounter,
  Return
} from '@api/apiClient';
import { Modal } from '@components/Modal';
import { ReactElement, useEffect, useState } from 'react';
import { Row, Column } from '@components/Grid';
import { TabsList, TabsContent } from '@components/Tabs/Tabs.tsx';
import { Tooltip } from '@components/new/Tooltip';
import { TSavingParcel, /* useSavingsCounter */ } from '@api/apiClient/saving';
import { useProfile } from '@contexts/ProfileContext';
import { useQuery, useQueryClient } from 'react-query';
import { useSellersCounter } from '@contexts/SellersCounterContext';
import { useTranslation } from 'react-i18next';

const UnclaimedPage = () => {
  const [filters, setFilters] = useState<FilterModel[]>([]);
  // const [isAutoResaleEnabled, setIsAutoResaleEnabled] = useState<boolean>(false);
  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [isOpenAutoResaleWindow, setIsOpenAutoResaleWindow] = useState<boolean>(false);
  const [savedAwaitingSelection, setSavedAwaitingSelection] = useState<string[]>([]);
  const [savedAwaitingReturnsSelection, setSavedAwaitingReturnsSelection] = useState<Return[]>([]);
  const [savedUnpaidSelection, setSavedUnpaidSelection] = useState<string[]>([]);
  const [savedUnpaidReturnsSelection, setSavedUnpaidReturnsSelection] = useState<Return[]>([]);
  const [savedDisposalSelection, setSavedDisposalSelection] = useState<string[]>([]);
  const [savedResaleSelection, setSavedResaleSelection] = useState<string[]>([]);
  const [savedRescueSelection, setSavedRescueSelection] = useState<TSavingParcel[]>([]);
  const [savedReturnsSelection, setSavedReturnsSelection] = useState<string[]>([]);

  const handlerSetSavedAwaitingSelection = (ids: string[], values: Return[]) => {
    setSavedAwaitingSelection(ids);
    setSavedAwaitingReturnsSelection(values);
  }
  const handlerSetSavedUnpaidSelection = (ids: string[], values: Return[]) => {
    setSavedUnpaidSelection(ids);
    setSavedUnpaidReturnsSelection(values);
  }

  const queryClient = useQueryClient();
  const { account } = useProfile();
  const { sellersNotFound } = useSellersCounter();
  const { t } = useTranslation();

  const { hasNoReturns: noData } = useHasReturns(!sellersNotFound);

  const { data: awaitingCounter } = useAwaitingCounter(!sellersNotFound);
  const { data: unpaidCounter } = useUnpaidCounter(!sellersNotFound);
  const { data: disposalCounter } = useDisposalCounter(!sellersNotFound);
  const { data: resaleCounter } = useResaleCounter(!sellersNotFound);
  const { data: returnsCounter } = useReturnsCounter(!sellersNotFound);
 // const { data: savingsCounter } = useSavingsCounter(!sellersNotFound);

  const {
    data: dataGetAutoResaleUnclaimedData,
    refetch: refetchGetAutoResaleUnclaimedData
  } = useQuery({
    queryKey: ['getAutoResaleUnclaimedData'],
    queryFn: () => getAutoResaleUnclaimedData(),
    retry: 1,
    enabled: !sellersNotFound
  });

  const { data: dataGetCountryTariffs } = useQuery({
    queryKey: ['getCountryTariffs'],
    queryFn: () => getCountryTariffs(),
    retry: 1
  });

  // useEffect(() => {
  //   dataGetAutoResaleUnclaimedData && setIsAutoResaleEnabled(dataGetAutoResaleUnclaimedData.enabled);
  // }, [dataGetAutoResaleUnclaimedData]);

  const refreshData = () => {
    queryClient.invalidateQueries(
      { queryKey: ["returns-page"] }
    );
    queryClient.invalidateQueries(
      { queryKey: ["resales-page"] }
    );
    queryClient.invalidateQueries(
        {queryKey: ["getSavings"]}
    );
  }

  useEffect(() => {
    if (filters[0]?.value.length) {
      setSavedRescueSelection([]);
      setSavedAwaitingSelection([]);
      setSavedDisposalSelection([]);
      setSavedResaleSelection([]);
      setSavedReturnsSelection([]);
    }
  }, [filters]);

  const downloadingExcelFile = (type: string): void => {
    let parcelsIds: string[] = [];
    let viewType: string = '';

    if (activeTab === 'rescue') viewType = 'Rescue';
    if (activeTab === 'awaiting') viewType = 'Awaiting';
    if (activeTab === 'disposal') viewType = 'Disposal';
    if (activeTab === 'resale') viewType = 'Resale';
    if (activeTab === 'returns') viewType = 'Return';
    if (activeTab === 'unpaid') viewType = 'AwaitingPayment';

    if (type === 'selectively') {
      if (activeTab === 'rescue') parcelsIds = savedRescueSelection.map(item => item.id);
      if (activeTab === 'awaiting') parcelsIds = savedAwaitingSelection;
      if (activeTab === 'disposal') parcelsIds = savedDisposalSelection;
      if (activeTab === 'resale') parcelsIds = savedResaleSelection;
      if (activeTab === 'returns') parcelsIds = savedReturnsSelection;
      if (activeTab === 'unpaid') parcelsIds = savedUnpaidSelection;
    }

    const data: getReturnsXLSXFileRequest = {
      FileType: 'Excel',
      LocalTimeUtcOffsetMinute: moment().utcOffset(),
      ParcelIds: parcelsIds,
      ReturnParcelViewType: viewType
    };

    getReturnsXLSXFile(data)
        .then((response: AxiosResponse) => {
          const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const fileURL = URL.createObjectURL(file);
          const element = document.createElement('a');
          element.setAttribute('href', fileURL);
          element.setAttribute('download', `${viewType} ${moment().format('DD/MM/YYYY HH:mm:ss')}`);
          element.style.display = 'none';
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        });
  };

  const downloadingTopBtn: ReactElement =
      <Button
          icon={ExcelIcon}
          onClick={() => downloadingExcelFile('all')}
          size={ButtonSize.S}
          type={ButtonType.ROUNDED}
          title={t('unclaimedPage.titleActionTop')}
      />;

  const downloadingBottomBtn: ReactElement =
      <Button
          icon={ExcelIcon}
          onClick={() => downloadingExcelFile('selectively')}
          size={ButtonSize.S}
          title={t('unclaimedPage.titleActionBottom')}
      />;

  const tabs = [
   /* ...((account?.region === 'TR') ? [{
      id: "rescue",
      title: t("unclaimedPage.tabRescue"),
      content: <RescueTab
          dataGetCountryTariffs={dataGetCountryTariffs!}
          filters={filters}
          pending={!isInitialized}
          handlerSetSavedSelection={setSavedRescueSelection}
          savedRescueSelection={savedRescueSelection}
          refreshData={refreshData}
          sellersNotFound={sellersNotFound}
      />,
      count: savingsCounter
    }] : []), */
    {
      id: "awaiting",
      title: t("unclaimedPage.tabAwaiting"),
      content: <AwaitingTab
        dataGetCountryTariffs={dataGetCountryTariffs!}
        filters={filters}
        pending={!isInitialized}
        downloadingBtn={downloadingBottomBtn}
        handlerSetSavedAwaitingSelection={handlerSetSavedAwaitingSelection}
        savedAwaitingSelection={savedAwaitingSelection}
        savedAwaitingReturnsSelection={savedAwaitingReturnsSelection}
        refreshData={refreshData}
        sellersNotFound={sellersNotFound}
        noData={noData}
      />,
      count: awaitingCounter
    },
    {
      id: "returns",
      title: t("unclaimedPage.tabReturns"),
      content: <ReturnsTab
          filters={filters}
          pending={!isInitialized}
          downloadingBtn={downloadingBottomBtn}
          handlerSetSavedReturnsSelection={setSavedReturnsSelection}
          savedReturnsSelection={savedReturnsSelection}
          refreshData={refreshData}
          sellersNotFound={sellersNotFound}
          noData={noData}
      />,
      count: returnsCounter,
      disable: noData || sellersNotFound,
    },
    ...((account?.region === 'TR') ? [] : [{
      id: "unpaid",
      title: t("unclaimedPage.tabUnpaid"),
      content: <UnpaidTab
        filters={filters}
        pending={!isInitialized}
        downloadingBtn={downloadingBottomBtn}
        handlerSetSavedSelection={handlerSetSavedUnpaidSelection}
        savedSelection={savedUnpaidSelection}
        savedReturnsSelection={savedUnpaidReturnsSelection}
        refreshData={refreshData}
        sellersNotFound={sellersNotFound}
        noData={noData}
      />,
      count: unpaidCounter,
    }]),
    {
      id: "resale",
      title: t("unclaimedPage.tabResales"),
      content: <ResaleTab
          filters={filters}
          pending={!isInitialized}
          downloadingBtn={downloadingBottomBtn}
          handlerSetSavedResaleSelection={setSavedResaleSelection}
          savedResaleSelection={savedResaleSelection}
          refreshData={refreshData}
          sellersNotFound={sellersNotFound}
          noData={noData}
      />,
      count: resaleCounter,
      disable: noData || sellersNotFound,
    },
    {
      id: "disposal",
      title: t("unclaimedPage.tabDisposal"),
      content: <DisposalTab
          filters={filters}
          pending={!isInitialized}
          downloadingBtn={downloadingBottomBtn}
          handlerSetSavedDisposalSelection={setSavedDisposalSelection}
          savedDisposalSelection={savedDisposalSelection}
          refreshData={refreshData}
          sellersNotFound={sellersNotFound}
          noData={noData}
      />,
      count: disposalCounter,
      disable: noData || sellersNotFound,
    },
  ];
  const { activeTab, setActiveTab } = useTab(tabs);

  useEffect(() => {
    setFilters([]);
  }, [activeTab]);

  const actionWrapper: ReactElement =
      <Tooltip
          action={downloadingTopBtn}
          position="bottom"
          right={55}
          text={t("unclaimedPage.actionTooltip")}
          top={51}
      />

  return (
    <Page
        actions={(activeTab === 'rescue') ? undefined : actionWrapper}
        title={t('unclaimedPage.title')}
    >
      <div className={styles.tabsRow}>
        <TabsList
          tabs={tabs}
          onChange={setActiveTab}
          value={activeTab || tabs[0].id}
        />
        <div className={styles.filters}>
          {/*{activeTab === 'awaiting' && (*/}
          {/*    <Button*/}
          {/*        disabled={!dataGetAutoResaleUnclaimedData}*/}
          {/*        className={cn(styles.autoResaleBtn, isAutoResaleEnabled ? styles.autoResaleBtnOn : styles.autoResaleBtnOff)}*/}
          {/*        icon={isAutoResaleEnabled ? AutoResaleOnIcon : AutoResaleOffIcon}*/}
          {/*        onClick={() => setIsOpenAutoResaleWindow(true)}*/}
          {/*        size={ButtonSize.S}*/}
          {/*        type={ButtonType.ROUNDED}*/}
          {/*        title={t('unclaimedPage.autoResaleBtn')}*/}
          {/*    />*/}
          {/*)}*/}
          <Button
            className={cn(isFilterOpen ? styles.filterBtnActive : styles.filterBtnInactive)}
            icon={FilterIcon}
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            size={ButtonSize.S}
            type={ButtonType.ROUNDED}
            title={t("filters.filters")}
          />
        </div>
      </div>
      <Box pb={5} className={cn(!isFilterOpen && styles.hidden)}>
        <Column phone={12}>
          <Row justify="right" gap={5}>
            <Filters
              key={activeTab}
              id={`unclaimed-${activeTab}`}
              openFilters={() => setIsFilterOpen(true)}
              items={sellersNotFound ? [] : [
                {
                  name: activeTab === "resale" ? "oldOrNewResaleNumbers" : "trackOrExternalNumbers",
                  type: FilterTypes.MULTI_SEARCH,
                  placeholder: t("parcelsPage.trackNumberSearch"),
                },
                {
                  name: "serviceIds",
                  type: FilterTypes.SERVICE_RETURNS,
                },
                {
                  name: "sellerIds",
                  type: FilterTypes.SELLER,
                },
                {
                  name: "marketplaceType",
                  type: FilterTypes.MARKETPLACE_FILTERED,
                },
                ...((activeTab === 'disposal') ? [
                  {
                    name: "returnTypeChangeInitiator",
                    type: FilterTypes.DISPOSED_BY,
                  }
                ] : []),
              ]}
              onChange={(v, isReady) => {
                if (isReady) {
                  setIsInitialized(true);
                }
                setFilters(v);
              }}
              values={filters}
              asPanel
            />
          </Row>
        </Column>
      </Box>

      <TabsContent
        tab={tabs.find((tab) => (tab.id === activeTab))}
      />
      <Modal
          isOpen={isOpenAutoResaleWindow}
          onClickOverlay={() => setIsOpenAutoResaleWindow(false)}
          onClose={() => setIsOpenAutoResaleWindow(false)}
          width={650}
      >
        <AutoResaleUnclaimedModalWindow
            autoResaleData={dataGetAutoResaleUnclaimedData!}
            onClose={() => setIsOpenAutoResaleWindow(false)}
            handlerRefetchData={refetchGetAutoResaleUnclaimedData}
        />
      </Modal>
    </Page>
  );
};

export default UnclaimedPage;
